import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as platformSettingsApi from '../Api/platformSettingsApi';

const PLATFORM_SETTINGS_KEY = 'platformSettings';
const NOTIFICATION_LOG_KEY = 'notificationLog';

export const usePlatformSettings = (enabled = true) =>
	useQuery({
		queryKey: [PLATFORM_SETTINGS_KEY],
		queryFn: async () => {
			const res = await platformSettingsApi.getPlatformSettings();
			return res.data;
		},
		enabled,
	});

export const useUpdatePlatformSettings = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (settings) =>
			platformSettingsApi.updatePlatformSettings(settings),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [PLATFORM_SETTINGS_KEY] });
			queryClient.invalidateQueries({ queryKey: ['publicFeatureFlags'] });
		},
	});
};

export const useSendTestPlatformNotification = () =>
	useMutation({
		mutationFn: () => platformSettingsApi.sendTestPlatformNotification(),
	});

export const useNotificationLog = (params = {}, enabled = true) =>
	useQuery({
		queryKey: [NOTIFICATION_LOG_KEY, params],
		queryFn: async () => {
			const res = await platformSettingsApi.getNotificationLog(params);
			return res.data;
		},
		enabled,
	});

export const usePublicFeatureFlags = () =>
	useQuery({
		queryKey: ['publicFeatureFlags'],
		queryFn: async () => {
			const res = await platformSettingsApi.getPublicFeatureFlags();
			return res.data;
		},
		staleTime: 60 * 1000,
	});
